export default __webpack_public_path__ + "static/media/cover.95e63451.png";